<template>
  <div class="container text-center mt-10">
    <loading
      v-model:active="isLoading"
      :can-cancel="true"
      :on-cancel="onCancel"
      :is-full-page="fullPage"
    />
    <div class="leaderBoard-wrapper">
      <h1 class="leaderBoard-title">LeaderBoard</h1>
      <div class="leaderBoard-body">
        <div class="scroll px-3">
          <div
            class="leaderBoard-content"
            v-for="(item, index) in info"
            :key="index"
          >
            <div class="leaderBoard-reward">
              <h6 class="text-white" v-if="index == 0">Rank</h6>
              <img src="/lostsailor/images/gold_medal.png" alt="" v-if="index == 0" />
              <img src="/lostsailor/images/Silver-Medal.png" alt="" v-if="index == 1" />
              <img src="/lostsailor/images/bronze-medal.png" alt="" v-if="index == 2" />
              <h4 v-if="index > 2">{{ index + 1 }}</h4>
            </div>
            <div class="leaderBoard-userImg">
              <small
                class="text-white font-weight-bold text-uppercase"
                v-if="index == 0"
                >Profile</small
              >
              <img src="images/gg_profile.png" alt="" />
            </div>
            <div class="leaderBoard-info">
              <h4 class="username">{{ item.account }}</h4>
              <h4 class="total-reward">{{ parseInt(item.xp) }}</h4>
            </div>
          </div>
        </div>
      </div>
      <button v-if="more" @click.prevent="init(next_key)" class="loadmore">
        Next 100
      </button>
      <div class="back">
        <router-link to="/dashboard">
          <i class="fa fa-angle-left text-white" aria-hidden="true"></i>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../services";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { useToast } from "vue-toastification";
const toast = useToast();
var allRec = [];
export default {
  name: "LeaderBoard",
  components: {
    Loading,
  },
  data() {
    return {
      error: false,
      searchTerm: "",
      isLoading: false,
      fullPage: true,
      more: false,
      next_key: false,
      info: null,
    };
  },
  mounted() {
    this.isLoading = true;
    this.init(null);
  },
  methods: {
    async init() {
      return await ApiService.getTableAll(
        "playersxp",
        async (result) => {
          if (result.rows.length > 0) {
            if (allRec) {
              allRec = [...new Set([...result.rows, ...allRec])];
            } else {
              allRec = result.rows;
            }
            allRec.sort((a, b) => (Number(a.xp) > Number(b.xp) ? -1 : 1));
            this.info = allRec.slice(0, 50);
            this.isLoading = false;
          }
        },
        (error) => {
          this.isLoading = false;
          toast.error(error);
        }
      );
    },
  },
};
</script>
<style scoped>
.loadmore {
  width: 200px;
  border: 1px solid #fff;
  padding: 5px;
  border-radius: 5px;
  margin-top: 10px;
  font-weight: bold;
}
</style>